module.exports = __webpack_public_path__ + "img/delete-icon.7f48b916.svg";